import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '../../ui/dialog';
import { Button } from '../../ui/button';
import { FileText, Wand2 } from 'lucide-react';

interface ConfirmUploadDialogProps {
  isOpen: boolean;
  files: File[];
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfirmUploadDialog: React.FC<ConfirmUploadDialogProps> = ({
  isOpen,
  files,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{t('dialog.confirmFilesTitle')}</DialogTitle>
          <DialogDescription>{t('dialog.confirmFilesHint')}</DialogDescription>
        </DialogHeader>

        <div className="grid gap-4 py-4">
          <h3 className="font-medium">{t('dialog.filesToUpload')}</h3>
          <div className="space-y-2 max-h-56 overflow-auto pr-1">
            {files.map((file, index) => (
              <div key={index} className="flex items-center p-2 rounded-md border bg-muted/20">
                <FileText className="h-4 w-4 mr-2 flex-shrink-0" />
                <span className="text-sm truncate block max-w-[22rem]" title={file.name}>
                  {file.name}
                </span>
              </div>
            ))}
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            {t('actions.back')}
          </Button>
          <Button onClick={onConfirm}>
            <Wand2 className="h-4 w-4 mr-2" />
            {t('actions.analyze')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
